import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pendingapprovals',
  templateUrl: './pendingapprovals.component.html',
  styleUrls: ['./pendingapprovals.component.css', './custom_style.css', './boot-outline-btn.css']
})
export class PendingapprovalsComponent implements OnInit {
  currentUser: any;
  pending_approvals: any;
  loading: any;
  constructor(public analytics: AnalyticsService, public approvalService: ApprovalsService, public DataService: DataService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.getPendingApprovals();
  }
  getPendingApprovals() {
    this.loading = true;
    this.analytics.getPendingApprovals(this.currentUser.token)
      .subscribe(data => {
        this.loading = false;
        this.pending_approvals = data;
      });
  }
}
